import React, { useEffect, useState } from 'react';
import { CardTitle, PageTitle, PseudoStates } from '@cordata/buffet';
import { useParams } from 'react-router-dom';
import { deburrObject } from '~/utils/api/normalizers';
import { authorizedInstance as Rb } from '~/utils';

import { Form } from '~/components/OutboundReferral';
import { ListGroup } from '~/components/Note';

const OutboundReferralsDetails = () => {
  const params = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();

  useEffect(() => {
    Rb.get(`outbound-referrals/${params.outboundReferralId}`)
      .then(r => deburrObject(r.data.data))
      .then(r => Object.keys(r).reduce((a, m) => {
        if (m === 'reason') {
          if (r[m]) {
            const rm = deburrObject(r[m]);

            return {
              ...a,
              reason: {
                ...rm,
                ...rm.referenceReason,
              },
            };
          }
          return a;
        } else if (m === 'status') {
          if (r[m]) {
            const rm = deburrObject(r[m]);

            return {
              ...a,
              status: {
                ...rm,
                ...rm.referenceStatus,
              },
            };
          }
          return a;
        }

        return {
          ...a,
          [m]: r[m] && typeof r[m] === 'object' && !Array.isArray(r[m]) ? deburrObject(r[m]) : r[m],
        };
      }, {}))
      .then(setData)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, []);

  if (status === 'success') {
    return (
      <>
        <PageTitle>Outbound Referral</PageTitle>

        <Form data={data} disabled />

        <div className="mt-5">
          <CardTitle>Previous Notes</CardTitle>

          <ListGroup
            notes={data.notes}
          />
        </div>
      </>
    );
  }

  return <PseudoStates status={status} />;
};

export default OutboundReferralsDetails;
